$(function(){
  loadImg('.puSlide, .case');
  initCaseSlick();

  $(window).on('load', function(){
    initMarquee();
  });

  $(window).on('scroll', function(){
    loadImg('.puSlide, .case');
  });
});

function loadImg(elem, resize) {
    $(elem).each(function() {
        var _this = $(this);
        if (_this.data('loaded')) return;
        if (winST > _this.offset().top - winH - 100) {
            _this.find('img').each(function() {
                if (!$(this).data('original')) return;
                $(this).attr('src', $(this).css('opacity', 0).data('original')).on('load', function(){
                    $(this).stop().animate({ opacity: 1 }, 500);
                    if (resize) $(window).trigger('resize');
                });
            });
            _this.data('loaded', true);
        }
    });
}
function initMarquee() {
  if (!$('.puSlide').length) return;

  $('.puSlide').slick({
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false,
    swipe: false,
	  arrows: false,
		lazyLoad: 'progressive',
  });

  $(window).resize(function(){
    if(isChange) {
      $('.puSlide').slick('unslick');
      initMarquee();
    }
  }).trigger('resize');
}

function initCaseSlick() {
  if (!$('.case').length) return;

  $('.case .caseSlick').slick({
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.case .prev'),
    nextArrow: $('.case .next'),
    dots: true,
    appendDots: $('.case .caseSwitch'),
	  pauseOnHover: false,
		lazyLoad: 'progressive',
  });

  $('.case .officeList .office').eq(0).addClass('on');
  $('.case .officeList').height($('.case .officeList .office.on').outerHeight());
  $('.case .caseSlick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.case .officeList .office').eq(nextSlide).addClass('on').siblings().removeClass('on');
    $('.case .officeList').height($('.case .officeList .office.on').outerHeight());
  });

  $(window).resize(function(){
    $('.case .officeList').height($('.case .officeList .office.on').outerHeight());
  });
}